/**
 * Payment System Constants
 * Phase 11 - Frontend Implementation
 */

import { InvoiceStatusUI } from '../types';

// Invoice Status UI Configuration
export const INVOICE_STATUS_UI: Record<string, InvoiceStatusUI> = {
  PENDING: {
    icon: '⏳',
    color: 'warning',
    label: 'Ожидает оплаты',
    labelKey: 'payments.statusAwaiting',
    actions: ['pay', 'download_pdf'],
    daysDisplay: 'Осталось {X} дней',
    daysDisplayKey: 'payments.daysLeft',
    warning: undefined,
  },
  PAID: {
    icon: '✅',
    color: 'success',
    label: 'Оплачено',
    labelKey: 'payments.statusPaid',
    actions: ['download_pdf'],
    daysDisplay: null,
    warning: undefined,
  },
  OVERDUE: {
    icon: '🔴',
    color: 'danger',
    label: 'ПРОСРОЧЕНО',
    labelKey: 'payments.statusOverdue',
    actions: ['pay', 'download_pdf'],
    daysDisplay: 'Просрочено на {X} дней',
    daysDisplayKey: 'payments.daysOverdueMsg',
    warning: '❌ Ваши роботы остановлены',
    warningKey: 'payments.overdueBotsStopped',
  },
  REFUNDED: {
    icon: '💰',
    color: 'info',
    label: 'Возвращено',
    labelKey: 'payments.statusRefunded',
    actions: ['download_pdf'],
    daysDisplay: null,
    warning: undefined,
  },
  CANCELLED: {
    icon: '❌',
    color: 'danger',
    label: 'Отменено',
    labelKey: 'payments.statusCancelled',
    actions: [],
    daysDisplay: null,
    warning: undefined,
  },
  DELETED: {
    icon: '🗑️',
    color: 'danger',
    label: 'Удалено',
    labelKey: 'payments.statusDeleted',
    actions: [],
    daysDisplay: null,
    warning: undefined,
  },
};

// Pagination
export const DEFAULT_PAGINATION = {
  USER_INVOICES_LIMIT: 20,
  ADMIN_INVOICES_LIMIT: 50,
  ADMIN_USERS_LIMIT: 25,
};

// Date Format
export const DATE_FORMAT = 'DD.MM.YYYY';
export const DATE_TIME_FORMAT = 'DD.MM.YYYY HH:mm';

// Notifications
export const NOTIFICATION_MESSAGES = {
  OVERDUE: 'У вас есть просроченные счета. Роботы остановлены.',
  PENDING_3DAYS: 'Осталось 3 дня для оплаты счета',
  PENDING_1DAY: 'СРОЧНО: Осталось 1 день для оплаты!',
  PAID_RECENT: 'Спасибо за оплату! Роботы возобновили работу',
  PAYMENT_SUCCESS: 'Оплата инициирована успешно',
  PAYMENT_ERROR: 'Ошибка при создании платежа. Попробуйте снова',
  COMMISSION_UPDATED: 'Комиссия успешно обновлена',
  PDF_DOWNLOADED: 'PDF успешно загружен',
};

// Default Commission
export const DEFAULT_COMMISSION_PERCENT = 15;

// Time Thresholds
export const TIME_THRESHOLDS = {
  NEAR_DEADLINE_DAYS: 3,
  CRITICAL_DEADLINE_DAYS: 1,
};

// API Paths (baseURL is /api, so paths should not include /api prefix)
export const API_PATHS = {
  // User Payments
  USER_INVOICES: '/user-payments/invoices',
  USER_INVOICE_DETAIL: '/user-payments/invoices/:invoiceId',
  USER_INVOICE_PDF: '/user-payments/invoices/:invoiceId/pdf',
  USER_PAYMENT_STATUS: '/user-payments/invoices/:invoiceId/payment-status',
  USER_PAYMENT_INITIATE: '/user-payments/invoices/:invoiceId/pay-with-nowpayments',
  USER_PAYMENT_STATISTICS: '/user-payments/statistics',
  USER_PAYMENT_CHECK_STATUS: '/user-payments/status',

  // Admin
  ADMIN_INVOICES: '/admin/payments/invoices',
  ADMIN_COMMISSION_GET: '/admin/payments/users/:userId/commission-rate',
  ADMIN_COMMISSION_SET: '/admin/payments/users/:userId/commission-rate',
  ADMIN_REPORTS_REVENUE: '/admin/payments/reports/revenue',
  ADMIN_BOT_DYNAMICS: '/admin/analytics/bot-dynamics',
  ADMIN_STRATEGY_PASSPORT_STATS: '/admin/analytics/strategy-passport-stats',
  ADMIN_ORPHAN_TRADES_CLEANUP: '/admin/analytics/users/:userId/orphan-trades-cleanup',
  ADMIN_INVOICE_VERIFY: '/admin/payments/invoices/:invoiceId/force-verify',
  ADMIN_INVOICE_REFUND: '/admin/payments/invoices/:invoiceId/refund-initiate',
  ADMIN_USER_LIFT_RESTRICTIONS: '/admin/payments/users/:userId/lift-restrictions',
  ADMIN_NOTIFICATIONS: '/admin/payments/notifications',
  ADMIN_NOTIFICATION_PUBLISH: '/admin/payments/notifications/:notificationId/publish',
  ADMIN_NOTIFICATION_UNPUBLISH: '/admin/payments/notifications/:notificationId/unpublish',
};

// Error Messages
export const ERROR_MESSAGES = {
  INVOICES_LOAD_ERROR: 'Ошибка при загрузке счетов',
  INVOICE_DETAIL_ERROR: 'Ошибка при загрузке деталей счета',
  PAYMENT_INIT_ERROR: 'Ошибка при инициации платежа',
  COMMISSION_LOAD_ERROR: 'Ошибка при загрузке комиссии',
  COMMISSION_UPDATE_ERROR: 'Ошибка при обновлении комиссии',
  REPORT_ERROR: 'Ошибка при загрузке отчета',
  INVALID_WALLET: 'Неверный адрес кошелька TON',
  NETWORK_ERROR: 'Ошибка сети. Проверьте соединение',
};
